import { render, staticRenderFns } from "./custom-column.vue?vue&type=template&id=4fb6539c&scoped=true"
import script from "./custom-column.vue?vue&type=script&lang=js"
export * from "./custom-column.vue?vue&type=script&lang=js"
import style0 from "./custom-column.vue?vue&type=style&index=0&id=4fb6539c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6539c",
  null
  
)

export default component.exports